export const CALENDAR_TAB_PATH = 'calendar';
export const RESULTS_TAB_PATH = 'results';
export const TOURNAMENT_TAB_PATH = 'tournaments';
export const BETHISTORY_TAB_PATH = 'betHistory';
export const MULTIVIEW_TAB_PATH = 'multiview';
export const OVERVIEW_TAB_PATH = 'overview';
